var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8958 10.5374C31.9216 10.5374 24.2741 13.7051 18.6355 19.3437C12.9969 24.9823 9.82915 32.6299 9.82915 40.6041C9.82915 48.5782 12.9969 56.2258 18.6355 61.8644C24.2741 67.503 31.9216 70.6707 39.8958 70.6707C47.87 70.6707 55.5176 67.503 61.1562 61.8644C66.7948 56.2258 69.9625 48.5782 69.9625 40.6041C69.9625 32.6299 66.7948 24.9823 61.1562 19.3437C55.5176 13.7051 47.87 10.5374 39.8958 10.5374ZM16.3727 17.081C22.6114 10.8423 31.0729 7.3374 39.8958 7.3374C48.7187 7.3374 57.1802 10.8423 63.4189 17.081C69.6576 23.3197 73.1625 31.7812 73.1625 40.6041C73.1625 49.4269 69.6576 57.8884 63.4189 64.1272C57.1802 70.3659 48.7187 73.8707 39.8958 73.8707C31.0729 73.8707 22.6114 70.3659 16.3727 64.1272C10.134 57.8884 6.62915 49.4269 6.62915 40.6041C6.62915 31.7812 10.134 23.3197 16.3727 17.081Z",
    fill: "url(#paint0_radial_1805_15941)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0241 29.7855C55.6489 30.4104 55.6489 31.4234 55.0241 32.0483L34.7552 52.3171L25.1185 42.6805C24.4937 42.0556 24.4937 41.0426 25.1185 40.4177C25.7434 39.7929 26.7564 39.7929 27.3813 40.4177L34.7552 47.7917L52.7613 29.7855C53.3862 29.1607 54.3992 29.1607 55.0241 29.7855Z",
    fill: "url(#paint1_radial_1805_15941)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1805_15941",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.5982 91.1694) rotate(-131.071) scale(161.65 526.627)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8B400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1805_15941",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.6482 58.2972) rotate(-139.446) scale(64.7971 210.538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8B400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.ad3519b06df9eb376f4f76e876b26574.svg";
export { ForwardRef as ReactComponent };